/**
 * Directive: resourceTypeView
 */
angular.module('acme.common.directive.resourceTypeView', [
  'acme.common.service.helpers'
])
.directive('resourceTypeView', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/resourceType/view/view.tpl.html',
      scope: {
        sref: '@',
        state: '@',
        name: '=',
        toggle: '=',
        model: '=',
        resourceIndex: '@resourceindex',
        disableActions: '@disableactions'
      },
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
        console.log($scope.toggle);
        $scope.$watch('model', $scope.resourceTypeView.onModelUpdate);

      },

      controller: ['$scope', 'HelpersService', function($scope, HelpersService) {

        $scope.resourceTypeView = {
          model: {},
          fields: [],

          toggle: false,

          init: function() {
          },

          toggleView: function() {
            return this.toggle = !this.toggle;
          },

          getFieldValue: function(field) {
            var r = [],
              list = HelpersService.getFieldValue(field);

            if (list instanceof Array) {
              r = list;
            }else if (list) {
              r = [list];
            }

            return (r.length > 0) ? r[0] : 'No Default Values';
          },

          hasValue: function(value) {
            console.log('resourceTypeView::hasValue', (value !== undefined), value);
            return (value !== undefined);
          },

          hasModelFields: function() {
            console.log('resourceType::hasFields', this.model.fields);
            return (this.model.fields && this.model.fields.length > 0);
          },
          
          edit: function() {
            $scope.$emit('resourceType::stateChange', {
              state: 'edit'
            });
          },

          remove: function() {
            $scope.$emit('resourceTypeView::remove', {
              resource: $scope.model,
              index: $scope.resourceIndex
            });
          },

          onModelUpdate: function(model) {
            console.log('resourceTypeView::onModelUpdate', model);

            $scope.resourceTypeView.model = model;

          }

        };

        $scope.resourceTypeView.init();

      }]

    };

}]);